
import axios from 'axios';
import axiosRetry from 'axios-retry';
import qs from 'qs';
import {v4 as uuid} from 'uuid';
import {sentryReport} from './sentry';

// 超时
// axios.defaults.timeout = 1000;
axios.defaults.baseURL = '';
axiosRetry(axios, {
    retries: 3,
    retryDelay: (retryCount:any) => retryCount * 1000
});

// 请求拦截
axios.interceptors.request.use(
    (config:any) => {
        console.log('接口请求', config);
        return config;
    }, (error:any) => {
        console.log('请求错误', error);
        sentryReport('接口请求错误', {
            tags: {
                apiType: 'req',
                apiUrl: error.config.url
            },
            extra: {
                error
            }
        });
        return Promise.reject(error);
    }
);

// 响应拦截
axios.interceptors.response.use((response:any) => {
    console.log('接口响应', response);
    if (response.data.code !== '0') {
        sentryReport('code不为0', {
            tags: {
                apiType: 'code0',
                apiUrl: response.config.url
            },
            extra: {
                url: response.config.url,
                requestData: response.config.data,
                responseData: response.data
            }
        });
    }
    return response.data;
},
(error:any) => {
    console.log('响应错误', error);
    sentryReport('接口响应错误', {
        tags: {
            apiType: 'res',
            apiUrl: error.config.url
        },
        extra: {
            error
        }
    });
    return Promise.reject(error);
});

function post(url:string, data:object) {
    const str = url.indexOf('?') > -1 ? '&' : '?';
    return axios({
        method: 'post',
        url,
        data,
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json; charset=UTF-8',
            'Authorization': 'mpweb'
        }
    });
}
function get(url:string, params: { [k: string]: any } = {}) {
    params.rid = uuid();
    return axios({
        method: 'get',
        url,
        // get 请求时带的参数
        params,
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Authorization': 'mpweb'
        }
    });
}
// 老接口用这种形式，默认采用x-www-form-urlencoded传输
function qsPost(url:string, data:any) {
    return axios({
        method: 'post',
        url,
        data: qs.stringify(data),
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Authorization': 'mpweb'
        }
    });
}
// 上传接口，使用 new FormData()
function uploadPost(url:string, data:object) {
    return axios({
        method: 'post',
        url,
        data,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

export default {
    post,
    get,
    qsPost,
    uploadPost,
};
